import React, { useEffect } from "react";
import Back1 from "../Images/back.jpg";
import Back2 from "../Images/JCPIC/back2.jpg";
import party from "../Images/JCPIC/IMG_5683.jpg";
import styled from "styled-components"; // Use styled-components for styling

const NewsContainer = styled.div`
  margin-top: 4px;
`;

const SectionTitle = styled.div`
  font-size: 3em;
  font-weight: 600;
  color: #dc143c;
`;

const ImageContainer = styled.div`
  width: 100%;
  background-position: center;
  background-size: cover;
  object-fit: cover;
`;

const ImageOverlay = styled.div`

  position: relative;
  height: 100%;
  display: flex;
  align-items: flex-end;
`;

const TextContent = styled.div`
  padding: 20px;
`;

const NewsTitle = styled.p`
  font-size: 1.5em;
  font-weight: 500;
  color: #dc143c;
`;

const NewsDescription = styled.p`
  font-size: 1em;
  font-weight: 500;
  color: #fff;
`;

const FeaturedImageContainer = styled(ImageContainer)`
  height: 80vh; // Larger height for the first image
`;

export default function News() {
  const Newsimages = [
    {
      img: party,
      title: "News-1",
      desc: "Jai Club announces upcoming elections — members are encouraged to participate actively in shaping the club's future leadership.",
    },
    {
      img: Back1,
      title: "News-2",
      desc: "Jai Club announces upcoming elections — members are encouraged to participate actively in shaping the club's future leadership.",
    },
    {
      img: Back2,
      title: "News-3",
      desc: "Jai Club announces upcoming elections — members are encouraged to participate actively in shaping the club's future leadership.",
    },
    {
      img: party,
      title: "News-4",
      desc: "Jai Club announces upcoming elections — members are encouraged to participate actively in shaping the club's future leadership.",
    },
  ];
  

  useEffect(() => {
    scrollToTop();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <NewsContainer>
      <div className="container">
        <SectionTitle className="text-center">News</SectionTitle>
        <div className="row">
          {/* Featured News - Larger Image */}
          <div className="col-lg-12 col-md-12 mb-3">
            <div className="card  ">
              <FeaturedImageContainer
                style={{ backgroundImage: `url(${party})` }}
              > 
                <ImageOverlay className="position-absolute top-50 start-50 translate-middle">
                  <TextContent className="text-center">
                    <NewsTitle>Upcoming News</NewsTitle>
                    <NewsDescription>
                    Jai Club announces upcoming elections — members are encouraged to participate actively in shaping the club's future leadership.
                    </NewsDescription>
                  </TextContent>
                </ImageOverlay>
              </FeaturedImageContainer>
            </div>
          </div>

          {/* Smaller News Items */}
          <div className="col-lg-12 col-md-12">
            <div className="row">
              {Newsimages.map((item, index) => (
                <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                  <div className="card border-0">
                    <ImageContainer
                      style={{
                        backgroundImage: `url(${item.img})`,
                        height: "70vh",
                      }}
                    >
                      <ImageOverlay>
                        <TextContent>
                          <NewsTitle><h5>{item.title}</h5></NewsTitle>
                          <NewsDescription><p>{item.desc}</p></NewsDescription>
                        </TextContent>
                      </ImageOverlay>
                    </ImageContainer>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </NewsContainer>
  );
}
